import { motion } from "framer-motion";
import { useT } from "../lib/prefs";

export const HeroOrb = ({ rx, ry }) => {
  const t = useT();
  return (
  <div className="absolute inset-0" style={{ perspective: 1200 }}>
    <motion.div
      initial={{ opacity: 0, scale: 0.85, rotateZ: -6 }}
      animate={{ opacity: 1, scale: 1, rotateZ: 0 }}
      transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1], delay: 0.5 }}
      style={{ rotateX: rx, rotateY: ry, transformStyle: "preserve-3d" }}
      className="relative w-full h-full"
    >
      <div className="absolute inset-[6%] rounded-[2rem] overflow-hidden border border-violet-400/30 shadow-[0_40px_120px_-20px_rgba(124,58,237,0.6)]" style={{ transform: "translateZ(0px)" }}>
        <img src="/img/class.webp" alt="Private class Rahsia Trading" className="w-full h-full object-cover object-[50%_35%]" data-testid="hero-class-photo" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B0518] via-violet-900/20 to-transparent" />
        <div className="absolute inset-0 bg-violet-700/15 mix-blend-color" />
        <div className="scanline absolute inset-0 opacity-50" />
        <div className="on-dark absolute bottom-5 right-5 sm:bottom-6 sm:right-6 font-mono text-xs tracking-[0.25em] text-violet-100 flex items-center gap-2">
          <span className="w-2 h-2 rounded-full bg-pink-400 animate-pulse" /> {t.sessionLabel}
        </div>
      </div>

      <div className="absolute top-[10%] right-0 sm:-right-4 glass rounded-2xl px-4 py-3 font-mono text-xs" style={{ transform: "translateZ(140px)" }} data-testid="hero-chip-fee">
        <div className="text-violet-200/80">{t.feeChip}</div>
        <div className="text-2xl font-display font-bold text-white">RM0</div>
      </div>
      <div className="absolute bottom-[4%] left-0 sm:-left-4 glass rounded-2xl px-4 py-3 font-mono text-xs" style={{ transform: "translateZ(120px)" }} data-testid="hero-chip-deposit">
        <div className="text-violet-200/80">DEPOSIT</div>
        <div className="text-2xl font-display font-bold text-white">0%</div>
      </div>
    </motion.div>
  </div>
  );
};
